export const nowJob = {
  title: 'Full-Stack Software developer',
  place: 'Investment Club Europe Limited',
  link: 'https://investmentclubeurope.com/',
  cvLink:
    'https://docs.google.com/document/d/1WxajxIxcq10T1gdRXbjLQpYlrZF_Zv2yXpNzUb0A15U/edit?usp=sharing',
}
